<template>
  
  <div class="ui basic segment datatable-segment" :class="{ loading }">

    <table :id="'dtbl_table_' + _uid" v-show="rows.length > 0" class="ui celled selectable tablet stackable table animated fadeIn">
      <thead v-if="$isDesktop">
        <tr>
          <th v-for="field in fields" v-if="showField(field)" class="clickable" @click="onSortBy(field)">
            {{ field.label }}       
            <i v-if="sort.prop == field.prop" class="arrow blue icon m-l-5" :class="{ down: sort.asc, up: !sort.asc }"></i>       
          </th>        
        </tr>
      </thead>
      <tbody> 
        <tr v-for="(row, index) in rows" :key="index" 
          :class="{ 'disabled-row': disabledRow(row), 'error': dangerRow(row) }" @click="$emit('onRowClick', { row, index })">
          <td v-for="field in fields" v-if="showField(field)">
            <strong class="mobile-only">{{ field.label }}: </strong>
            <span v-if="field.render" v-html="field.render(row, index)"></span>
            <span v-else>{{ getRowProp(row, field.prop) }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <p v-if="showNotFoundMessage" class="grey text animated fadeIn m-t-10">
      <i class="info circle icon"></i> Nenhum registro encontrado
    </p> 

    <div v-if="loadingMore">
      <i class="spinner circle loading blue icon"></i> Carregando ...
    </div> 

  </div>

</template>

<script>

  import AppBrowser from "@/utils/browser"

  export default {
    
    name: "DataTable",

    data() {
      return {
        loaded: false,
        loading: false,
        loadingMore: false,
        rows: [],
        search: "",
        sort: { prop: "", model: null, orderModelAlias: null, asc: true },
        filterData: null,
        scrollTop: 0,
      }
    },

    props: {
      id: { type: String, required: true },
      service: { required: true },
      attributes: { type: Array, default: [] },
      fields: { type: Array, default: [] },      
      disabled: { type: Function },
      danger: { type: Function },
      blocks: { type: Number, default: 30 },
      saveScroll: { type: Boolean, default: false },
      saveState: { type: Boolean, default: true },
      sortBy: { type: String },
      asc: { type: Boolean, default: true },
      autoLoad: { type: Boolean, default: true },
    },

    created() {

      let dtbl = this.$store.state.pages.dataTables[this.id]
      let shouldReload = (this.$store.state.pages.reloadDataTables.indexOf(this.id) > -1)

      this.checkSortProp()

      if (!this.saveState || !dtbl) {

        if (this.autoLoad)
          this.load()
                        
      } else {
        
        this.loadFromStore()

        if (shouldReload) {
          
          this.reload(dtbl)

        } else if (this.saveScroll) {
          
          AppBrowser.scrollTop({ top: this.scrollTop })
        } 
      }
    },

    mounted() {
      $(`#dtbl_table_${this._uid}`).visibility({
        once: false,
        observeChanges: true,
        onBottomVisible: this.loadMore,
      })
    },

    beforeDestroy() {      
      this.saveInStore()
    },

    computed: {

      showNotFoundMessage() {

        if (!this.autoLoad && !this.loaded)
          return false

        return (this.rows.length == 0 && !this.loading)
      },
    },

    methods: {

      async load(search, limit, restoreScroll) {                

        this.loading = true
        this.search = search

        try {
                                
          const rows = await this.service.findAll({
            search,
            attributes: this.attributes,
            limit: limit || this.blocks,
            order: this.sort.prop,
            orderModel: this.sort.model,
            orderModelAlias: this.sort.modelAlias,
            sort: this.sort.asc ? "ASC" : "DESC",
          })        
          
          this.setRows(rows, restoreScroll)
          
        } catch (error) {
          
          console.log("Falha ao carregar dados do DataTable")
          console.log(error)
        
        } finally {

          this.loading = false
        }
      },

      async loadMore() {

        if (this.rows.length < this.blocks)
          return

        this.loadingMore = true

        let newRows = []
        let rows = this.rows.slice()        

        try {    

          const options = {
            attributes: this.attributes,
            limit: this.blocks,
            offset: this.rows.length,
            order: this.sort.prop,
            orderModel: this.sort.model,
            orderModelAlias: this.sort.modelAlias,
            sort: this.sort.asc ? "ASC" : "DESC",
          }

          if (this.filterData) {

            newRows = await this.service.filter({
              ...this.filterData,
              ...options,
            })

          } else {

            newRows = await this.service.findAll({
              search: this.search,
              ...options,
            })
          }
          
          for (let index = 0; index < newRows.length; index++) {
            rows.push(newRows[index])
          }

          this.setRows(rows)
          
        } catch (error) {
          
          console.log("Falha ao carregar mais dados do DataTable")
          console.log(error)
        
        } finally {

          this.loadingMore = false
        }
      },

      async filter(data, limit, restoreScroll) {

        this.loading = true
        this.search = ""
        this.filterData = this.$cloneObject(data)

        try {
                                
          const rows = await this.service.filter({
            ...data,
            attributes: this.attributes,
            limit: limit || this.blocks,
            order: this.sort.prop,
            orderModel: this.sort.model,
            orderModelAlias: this.sort.modelAlias,
            sort: this.sort.asc ? "ASC" : "DESC",            
          })          

          this.setRows(rows, restoreScroll)
          
        } catch (error) {
          
          console.log("Falha ao filtrar registros para o DataTable")
          console.log(error)
        
        } finally {

          this.loading = false
        }
      },      

      reload(dtbl) {

        const limit = this.rows.length > this.blocks ? this.rows.length : this.blocks
        const restoreScroll = true

        if (dtbl.filterData) {
          this.filter(dtbl.filterData, limit, restoreScroll)
        } else {
          this.load(dtbl.search, limit, restoreScroll)
        }
      },

      refresh() {

        const limit = this.rows.length > this.blocks ? this.rows.length : this.blocks

        if (this.filterData) {
          this.filter(this.filterData, limit)
        } else {
          this.load(this.search, limit)
        }
      },

      clearFilter(search) {

        this.search = ""
        this.filterData = null
        
        this.load(search)
      },

      showField(field) {

        let show = true

        if (typeof field.visible == "function") {
          show = field.visible()
        } else if (typeof field.visible == "boolean") {
          show = field.visible
        }          
        
        return show
      },

      getRowProp(obj, propName) {

        let prop = obj
        const parts = propName.split( "." )        

        for (let index = 0; index < parts.length; index++) {
          prop = prop[parts[index]]
        }

        return prop
      },

      disabledRow(row) {
        if (this.disabled) {
          return this.disabled(row)
        } else {
          return false
        }
      },

      dangerRow(row) {
        if (this.danger) {
          return this.danger(row)
        } else {
          return false
        }
      },

      setRows(rows, restoreScroll) {

        this.rows = rows.slice()
        
        this.setReloaded()

        if (restoreScroll && this.saveScroll) {
          AppBrowser.scrollTop({ top: this.scrollTop })
        }  

        this.loaded = true
      },

      setReloaded() {

        if (!this.saveState)
          return

        let reloadDataTables = this.$store.state.pages.reloadDataTables.slice()
        const index = reloadDataTables.indexOf(this.id)

        if (index > -1) {
          reloadDataTables.splice(index, 1)
          this.$store.commit("pages/setReloadDataTables", reloadDataTables)
        }   
      },

      saveInStore() {

        if (!this.saveState)
          return

        let dtbls = this.getStoreDataTables()
        
        dtbls[this.id].rows = this.rows
        dtbls[this.id].search = this.search
        dtbls[this.id].sort = this.sort
        dtbls[this.id].filterData = this.filterData
        dtbls[this.id].scrollTop = window.scrollY
        
        this.$store.commit("pages/setDataTables", dtbls)   
      },

      getStoreDataTables() {

        let dtbls = this.$cloneObject(this.$store.state.pages.dataTables)

        if (!dtbls[this.id])
          dtbls[this.id] = { rows: [], search: "", sort: {}, filterData: null, scrollTop: 0 }

        return dtbls  
      },

      loadFromStore() {

        const dtbl = this.getStoreDataTables()[this.id]  

        this.rows = dtbl.rows.slice()
        this.search = dtbl.search
        this.sort = dtbl.sort
        this.filterData = dtbl.filterData
        this.scrollTop = dtbl.scrollTop
      },

      checkSortProp() {

        if (this.sort.prop)
          return
        
        this.sort.asc = true 
        this.sort.model = null

        if (typeof this.asc == "boolean")
          this.sort.asc = this.asc        

        const field = this.sortBy ? this.getFieldByProp(this.sortBy) : this.fields[0]

        this.sort.prop = field.prop
        this.sort.model = field.model
        this.sort.modelAlias = field.modelAlias
      },

      getFieldByProp(prop) {

        for (let field of this.fields) {
          if (field.prop === prop)
            return field
        }

        return {}
      },

      onSortBy(field) {

        if (field.sortDisabled)
          return

        this.sort.asc = field.prop !== this.sort.prop ? true : !this.sort.asc
        this.sort.prop = field.prop   
        this.sort.model = field.model  
        this.sort.modelAlias = field.modelAlias
        
        if (this.filterData) {
          this.filter(this.filterData)
        } else {
          this.load(this.search)
        }        
      },

      setLoading(loading) {
        this.loading = loading
      },
    },
  }

</script>